import { dateToIsoString } from 'helper/helper';
import { toToolNames } from './missionTemplateFormat';

export const MISSION_INSTRUCTIONS_MAX_LENGTH = 500;

const asText = (value) => (typeof value === 'string' ? value : '');

/** What a mission takes from the job description it starts from. The
 *  instructions only prefill the details step: the admin changes them for this
 *  mission, and the template keeps its own. */
export const buildMissionDataFromTemplate = (template) => ({
  missionTemplate: template,
  title: template?.title || template?.qualification || '',
  activity: template?.activity || '',
  tools: toToolNames(template?.tools),
  licences: template?.licences || [],
  languages: template?.language || [],
  contact_name: template?.contact?.name || '',
  contact_poste: template?.contact?.poste || '',
  location: template?.location || '',
  salary:
    typeof template?.salary?.wage_per_hour === 'number'
      ? String(template.salary.wage_per_hour)
      : '',
  other: asText(template?.other),
  other_interim: asText(template?.other_interim),
});

/** The creation request of a mission made from a job description. The api
 *  falls back on the template's instructions only when the keys are missing,
 *  so both are always sent, empty when the admin cleared them. */
export const buildTemplateMissionPayload = (dataCreateMission) => {
  const payload = {
    ...dataCreateMission,
    missionTemplateId: dataCreateMission.missionTemplate?._id,
    other: asText(dataCreateMission.other),
    other_interim: asText(dataCreateMission.other_interim),
  };
  if (payload.dateStart)
    payload.dateStart = dateToIsoString(new Date(payload.dateStart));
  if (payload.dateEnd)
    payload.dateEnd = dateToIsoString(new Date(payload.dateEnd));
  if (Array.isArray(payload.schedule)) {
    payload.schedule = payload.schedule.map((week) => ({
      ...week,
      days: week.days?.map((day) => ({
        ...day,
        date: day.date ? dateToIsoString(new Date(day.date)) : day.date,
      })),
    }));
  }
  return payload;
};
